<div class="modal-content">
    <div class="modal-header">
        <h4 class="modal-title fw-bold">{{ 'study-editor.study-dataset.accept-pending-modal.title' | translate }}</h4>
        <button type="button" class="btn-close" (click)="cancel()"></button>
    </div>
    <div class="modal-body">
        <div class="row pt-3">
            <div class="col-xs-12 col-md-12">
                {{ 'study-editor.study-dataset.accept-pending-modal.description' | translate }}
            </div>
        </div>
        <div class="row pt-3">
            <div class="col-xs-6 col-md-6">
                <strong>{{ 'study-editor.study-dataset.accept-pending-modal.select-option' | translate }}</strong>
            </div>
            <div class="col-xs-6 col-md-6">
                <ng-select [(ngModel)]="selected" [clearable]="false">
                    <ng-option
                            [value]="'ACCEPT_ALL'">{{ 'study-editor.study-dataset.accept-pending-modal.accept-all' | translate }}
                    </ng-option>
                    <ng-option
                            [value]="'SET_TO_MISSING'">{{ 'study-editor.study-dataset.accept-pending-modal.set-to-missing' | translate }}
                    </ng-option>
                </ng-select>
            </div>
        </div>
    </div>
    <div class="modal-footer">
        <button class="btn btn-secondary" (click)="cancel()">{{ 'cancel' | translate }}</button>
        <button class="btn btn-primary" (click)="proceed()">{{ 'proceed' | translate }}</button>
    </div>
</div>
